<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']"  @click="selectToobar('upper')">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="26" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">换排序杆</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="13px" x="0.5" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Stream division core</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="38" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">换芯棒</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="25" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Core rod</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="35" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">调摆叶</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="17" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Swing vane</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'principle'}, 'toolbar-item']" @click="selectToobar('principle')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="40" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">原 理</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="22" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Principle</textPath>
                            </text>
                        </g>
                            <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                            rx: 椭圆X轴半径
                            ry: 椭圆Y轴半径
                            xr: 椭圆旋转角度
                            laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                            sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                            x: 终点X轴坐标
                            y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'upper'">
              <div
                v-for="(item,index) in upperObj"
                :key="index"
                :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                @click="upperAnimate(item)"
              >
                  <template v-if="lang == 'cn'">
                      {{ item.text }}
                  </template>
                  <template v-if="lang == 'en'">
                      {{ item.en_text }}
                  </template>
              </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
              <div
                v-for="(item,index) in downObj"
                :key="index"
                :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                @click="downAnimate(item)"
              >
                  <template v-if="lang == 'cn'">
                      {{ item.text }}
                  </template>
                  <template v-if="lang == 'en'">
                      {{ item.en_text }}
                  </template>
              </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'outer'">
              <div
                v-for="(item,index) in outerObj"
                :key="index"
                :class="[{'active':outerActive === item.id}, 'app-submenu-item']"
                @click="outerAnimate(item)"
              >
                  <template v-if="lang == 'cn'">
                      {{ item.text }}
                  </template>
                  <template v-if="lang == 'en'">
                      {{ item.en_text }}
                  </template>
              </div>
            </div>

            <div class="app-submenu-wrap" v-if="toobarActive === 'principle'">
              <div
                v-for="(item,index) in principleObj"
                :key="index"
                :class="[{'active':principleActive === item.id}, 'app-submenu-item']"
                @click="principleAnimate(item)"
              >
                  <template v-if="lang == 'cn'">
                      {{ item.text }}
                  </template>
                  <template v-if="lang == 'en'">
                      {{ item.en_text }}
                  </template>
              </div>
            </div>

        </div>
        <!-- 配件列表 -->
        <div class="sub-nav">
          <div
            class="sub-item"
            v-for="(item,index) in accessoryObj"
            :key="index"
            @click="focusaccessory(item)"
            :class="{'accessoryactive':accessoryActive === item.id}"
          >
            <template v-if="lang == 'cn'">
                {{ item.text }}
            </template>
            <template v-if="lang == 'en'">
                {{ item.en_text }}
            </template>
          </div>
        </div>
        <!-- 图片/gif注解 -->
        <transition>
          <div class="img_annotate" v-if="img_annotate_status">
            <!-- <img src="/static/image/open.png" alt="" srcset=""> -->
            <video src="../assets/video/test.mp4" class="video" autoplay ref="videoObj"></video>
          </div>
        </transition>
        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>

        <!-- <div @click="test" class="test">测试</div> -->
    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'
    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    export default {
        components: {
            Loader,
            Nav,
            language,
        },
        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态
                accessoryActive:null,

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                is_hidenote:true,

                upperActive:null, //当前选项下标
                downActive:null, //当前选项下标
                outerActive:null, //当前选项下标
                principleActive:null, //当前选项下标
                modelanimationList:[], //动画列表
                selectobject: '', //当前选择的选项
                img_annotate_status:false,

                localPlane_BRG_B: new THREE.Plane(new THREE.Vector3(0, 1, 0), -4),
                localPlane_BRG_R: new THREE.Plane(new THREE.Vector3(0, 1, 0), -4),
                localPlane_BRG_G: new THREE.Plane(new THREE.Vector3(0, 1, 0), -4),
                localPlane_BRR_B: new THREE.Plane(new THREE.Vector3(0, 1, 0), -4),
                localPlane_BRR_R: new THREE.Plane(new THREE.Vector3(0, 1, 0), -4),
                localPlane_BRB_B: new THREE.Plane(new THREE.Vector3(1, 0, 0), -2),
                localPlane_BRB_R: new THREE.Plane(new THREE.Vector3(0, 1, 0), -3),

                lang: 'cn', // 语言
                upperObj:[ //1选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'The first step', //菜单显示(英文)
                    warn: '<p>1.松开排序杆盖板紧固螺丝</p>',
                    en_warn: '<p>1.Loosen the screws</p>',
                    animate_number: '0',
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'The second step', //菜单显示(英文)
                    warn: '<p>2.取下排序杆盖板</p>',
                    en_warn: '<p>2.Take the cover down</p>',
                    animate_number: '1',
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'The third step', //菜单显示(英文)
                    warn: '<p>3.松开排序杆紧固螺丝,利用顶出螺丝孔将排序杆顶出，按需求更换排序杆</p>',
                    en_warn: '<p>3.Use the ejector screw hole to push out the stream division core. </p>',
                    animate_number: '2',
                  },
                  {
                    id: 3,
                    text: '第四步', //菜单显示
                    en_text: 'The fourth step', //菜单显示(英文)
                    warn: '<p>4.将所需的排序杆按方向装回后，对角依次均匀拧紧紧固螺丝</p>',
                    en_warn: '<p>4.Install the replacement core to the right direction and tighten all fastening screws diagonally one by one.</p>',
                    animate_number: '3',
                  },
                  {
                    id: 4,
                    text: '第五步', //菜单显示
                    en_text: 'The fifth step', //菜单显示(英文)
                    warn: '<p>5.将所需的排序杆按方向装回后，对角依次均匀拧紧紧固螺丝</p>',
                    en_warn: '<p>5.Install the replacement core to the right direction and tighten all fastening screws diagonally one by one.</p>',
                    animate_number: '4',
                  },
                ],
                downObj: [ //2选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'The first step', //菜单显示(英文)
                    warn: '<p>1.松开芯棒盖板紧固螺丝将其取出</p>',
                    en_warn: '<p>1.Loosen the screws and take them out</p>',
                    animate_number: '6',
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'The second step', //菜单显示(英文)
                    warn: '<p>2.取出芯棒，按需求更换或修整芯棒，最后选择合适的芯棒。<br/>当表层两边偏薄时，更换全开且两端加深的芯棒;<br/>当表层两边偏厚时,更换开口宽度更小的芯棒</p>',
                    en_warn: '<p>2.Take out the core rod bar for replacing or trimming.<br/>When the surface layer is thinner on both sides, replace the bar with a new one of wider opening and deeper ends.<br/>When the surface layer is thicker on both sides, replace it with a bar of smaller opening width.</p>',
                    animate_number: '7',
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'The third step', //菜单显示(英文)
                    warn: '<p>3.最后选择合适的芯棒装入分配器机体内，调整好安装角度使芯棒的刻度对准ON，装好芯棒盖板后拧紧紧固螺丝</p>',
                    en_warn: '<p>3.Select the appropriate core rod bar to install it into the feedblock, adjust the installation angle to align the scale of the bar with ON, install the cover plate, and then tighten the screws.</p>',
                    animate_number: '8',
                  },
                ],
                outerObj: [ //3选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'The first step', //菜单显示(英文)
                    warn: '<p>1.摆叶调节杆上的调节螺丝向下调节可以使摆叶旋转一定的角度，使摆叶开口变大；摆叶调节杆上的调节螺丝向上调节可以使摆叶片旋转一定的角度，使摆叶开口变小；以此来控制各复合层比例。摆叶调节杆的顶端有指针，指针对应刻度尺上的数值即摆叶开口大小，调节完成后需拧紧调节螺丝（注意：调节时需在工艺温度下或内部没有原料时进行，且不可超过刻度尺上的范围）</p>',
                    en_warn: "<p>1.Adjusting the adjustment screw on the swing vane adjustment rod can cause the swing vane to rotate, thereby increasing or decreasing the opening  by a certain degree, controlling the proportion of each composite layer. There is a pointer corresponding to the scale at the top of the swing vane adjustment rod, indicating the size of the swing vane's opening.</p>",
                    animate_number: '11',
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'The second step', //菜单显示(英文)
                    warn: '<p>2.摆叶调节杆上的调节螺丝向下调节可以使摆叶旋转一定的角度，使摆叶开口变大；摆叶调节杆上的调节螺丝向上调节可以使摆叶片旋转一定的角度，使摆叶开口变小；以此来控制各复合层比例。摆叶调节杆的顶端有指针，指针对应刻度尺上的数值即摆叶开口大小，调节完成后需拧紧调节螺丝（注意：调节时需在工艺温度下或内部没有原料时进行，且不可超过刻度尺上的范围）</p>',
                    en_warn: "<p>1.Adjusting the adjustment screw on the swing vane adjustment rod can cause the swing vane to rotate, thereby increasing or decreasing the opening  by a certain degree, controlling the proportion of each composite layer. There is a pointer corresponding to the scale at the top of the swing vane adjustment rod, indicating the size of the swing vane's opening.</p>",
                    animate_number: '10',
                  },
                ],
                principleObj: [
                  {
                    id: 0,
                    text: 'ABC', //菜单显示
                    en_text: 'ABA', //菜单显示(英文)
                    warn: '',
                    en_warn: '',
                  },
                  {
                    id: 1,
                    text: 'ABB', //菜单显示
                    en_text: 'ABA', //菜单显示(英文)
                    warn: '',
                    en_warn: '',
                  },
                  {
                    id: 2,
                    text: 'ABA', //菜单显示
                    en_text: 'ABA', //菜单显示(英文)
                    warn: '',
                    en_warn: '',
                  },
                ],
                accessoryObj: [
                  {
                    id: 0,
                    text: '排序杆ABA', //菜单显示
                    en_text: 'Stream division core ABA', //菜单显示(英文)
                  },
                  {
                    id: 1,
                    text: '排序杆ABC', //菜单显示
                    en_text: 'Stream division core ABC', //菜单显示(英文)
                  },
                  {
                    id: 2,
                    text: '排序杆ABB', //菜单显示
                    en_text: 'Stream division core ABB', //菜单显示(英文)
                  },
                  {
                    id: 3,
                    text: '排序杆BBA', //菜单显示
                    en_text: 'Stream division core BBA', //菜单显示(英文)
                  },
                  {
                    id: 4,
                    text: '排序杆BBB', //菜单显示
                    en_text: 'Stream division core BBB', //菜单显示(英文)
                  },
                  {
                    id: 5,
                    text: '芯棒一', //菜单显示
                    en_text: 'Stream division bar No.1', //菜单显示(英文)
                  },
                  {
                    id: 6,
                    text: '芯棒二', //菜单显示
                    en_text: 'Stream division bar No.2', //菜单显示(英文)
                  },
                  {
                    id: 7,
                    text: '芯棒三', //菜单显示
                    en_text: 'Stream division bar No.3', //菜单显示(英文)
                  },
                ]
            }
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;

              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
          },
          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },
          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, 10);
            _this.camera.lookAt(_this.scene.position);
          },
          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/scbyfpq/scbyfpq.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })
                _this.modelanimationList = gltf.animations
                _this.modelLoaded = true;
                _this.scene.add(_this.model);
                _this.initmodel()
                _this.optimization_model_meaterial_performance()
                _this.model.getObjectByName("BRG_B").material.clippingPlanes = [_this.localPlane_BRG_B];
                _this.model.getObjectByName("BRG_R").material.clippingPlanes = [_this.localPlane_BRG_R];
                _this.model.getObjectByName("BRG_G").material.clippingPlanes = [_this.localPlane_BRG_G];

                _this.model.getObjectByName("BRR_B").material.clippingPlanes = [_this.localPlane_BRR_B];
                _this.model.getObjectByName("BRR_R").material.clippingPlanes = [_this.localPlane_BRR_R];

                _this.model.getObjectByName("BRB_B").material.clippingPlanes = [_this.localPlane_BRB_B];
                _this.model.getObjectByName("BRB_R").material.clippingPlanes = [_this.localPlane_BRB_R];

                _this.animate();
              });
          },
          //初始化状态
          initmodel(){
            let _this = this
            _this.showallcomponents()
            _this.ShowHideComponents(["ABC","BRG_B","BRG_R","BRG_G","BRR_B","BRR_R","BRB_B","BRB_R","ABCG","DCLS","ABBG2","BBBG","BBAG","XB1","XB2","XB3","XB4","ABBG","ABAGK","ABCGK","B1","B2","B3"],false)
          },
          optimization_model_meaterial_performance(){
            let _this = this;
            _this.model.traverse(function (object) {
              if (object.isMesh && object.material.isMeshPhysicalMaterial) {
                console.log(object,'isMeshPhysicalMaterial');
                let now_material = object.material
                // 创建一个新的 MeshStandardMaterial，可以根据需要调整属性
                let materialStandard = new THREE.MeshStandardMaterial({
                  color: now_material.color,
                  roughness: now_material.roughness, // 粗糙度
                  metalness: now_material.metalness, // 金属度
                  normalMap: now_material.normalMap, // 法线贴图
                  roughnessMap: now_material.roughnessMap, // 粗糙贴图
                  normalScale: now_material.normalScale, // 法线贴图强度
                  // 其他属性根据需要进行调整或者添加
                });
                // 将模型的材质替换为新的 MeshStandardMaterial
                object.material = materialStandard;
              }
            })
          },
          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },
          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },
          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },
          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
              this.img_annotate_status = false
              this.initmodel()
              this.initlocalPlane()
              this.attentionStatus = false
              if(this.clipAction){ //如果有动画则先停止播放
                this.clipAction.stop()
              }
            }else{
              this.toobarActive = e;
              this.attentionStatus = true
            }
            if(this.accessoryActive != null){
              this.initmodel()
              this.accessoryActive = null
              var oldP = { //旧的相机位置
                x: this.camera.position.x,
                y: this.camera.position.y,
                z: this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: this.controls.target.x,
                y: this.controls.target.y,
                z: this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 10,
              }
              this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          /**
           * @description 菜单选项1
           * @param {number} e 菜单选项对象
           */
          upperAnimate: function(item) {
            let _this = this;
            this.upperActive = item.id
            this.downActive = null
            this.outerActive = null
            this.principleActive = null
            this.accessoryActive = null
            this.img_annotate_status = false
            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }

            _this.initmodel()
            if(item.id == 2){
              _this.ShowHideComponents(["DCLS"],true)
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候

            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP
            switch (item.id) {
              case 0:
                newP = { //新的相机位置
                  x : 8.22,
                  y : 2.33,
                  z : -7.40
                }
                break;
              case 1:
                newP = { //新的相机位置
                  x : 7.27,
                  y : 6.27,
                  z : 9.02,
                }
                break;
              case 2:
                newP = { //新的相机位置
                  x : 7.27,
                  y : 6.27,
                  z : 9.02,
                }
                _this.ShowHideComponents(["ABBG"],true)
                break;
              case 3:
                newP = { //新的相机位置
                  x : 7.27,
                  y : 6.27,
                  z : 9.02,
                }
                _this.ShowHideComponents(["ABBG"],true)
                _this.ShowHideComponents(["ABAG"],false)
                break;
              case 4:
                newP = { //新的相机位置
                  x : 8.22,
                  y : 2.33,
                  z : -7.40
                }
                _this.ShowHideComponents(["ABBG"],true)
                _this.ShowHideComponents(["ABAG"],false)
                break;
              default:
                break;
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          downAnimate: function(item) {
            let _this = this;
            this.downActive = item.id
            this.upperActive = null
            this.outerActive = null
            this.principleActive = null
            this.accessoryActive = null
            this.img_annotate_status = false
            this.selectobject = item
            _this.initmodel()
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候

            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP
            switch (item.id) {
              case 0:
                newP = { //新的相机位置
                  x : 10.54,
                  y : 3.30,
                  z : 7.19,
                }
                break;
              case 1:
                newP = { //新的相机位置
                  x : 10.54,
                  y : 3.30,
                  z : 7.19,
                }
                _this.ShowHideComponents(["XB3","XB4"],true)
                break;
              case 2:
                newP = { //新的相机位置
                  x : 10.54,
                  y : 3.30,
                  z : 7.19,
                }
                _this.ShowHideComponents(["XB3","XB4"],true)
                break;
              default:
                break;
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
          },
          /**
           * @description 菜单选项3
           * @param {Number} e 菜单选项对象
           */
          outerAnimate: function(item) {
            let _this = this;
            this.outerActive = item.id
            this.downActive = null
            this.upperActive = null
            this.principleActive = null
            this.accessoryActive = null
            this.selectobject = item
            this.$nextTick(()=>{
              _this.videoDom = this.$refs.videoObj
              _this.videoDom.currentTime = 0
              _this.videoDom.play()
            })

            _this.initmodel()
            // _this.transparentComponents(["ZCGB","CGB"],0.1)
            _this.ShowHideComponents(["ZCGB","CGB"],false)
            this.img_annotate_status = true
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: 6,
              y: 0,
              z: 0,
            }
            _this.tweenCamera(oldP, oldT, newP, newT);

            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            _this.mixer.addEventListener('finished', function( e ) { //全部动作的结束时调用
              _this.outerActive = null
            });
          },
          /**
           * @description 菜单选项4
           * @param {Number} e 菜单选项对象
           */
          principleAnimate: function(item){
            let _this = this;
            this.principleActive = item.id
            this.outerActive = null
            this.downActive = null
            this.upperActive = null
            this.img_annotate_status = false
            this.selectobject = item
            _this.initmodel()
            _this.initlocalPlane()
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            if(_this.tweenplane){
              _this.tweenplane.stop()
            }
            if(_this.tweenplane2){
              _this.tweenplane2.stop()
            }
            if(_this.tweenplane3){
              _this.tweenplane3.stop()
            }
            var oldP = { //旧的相机位置
              x: _this.camera.position.x,
              y: _this.camera.position.y,
              z: _this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: _this.controls.target.x,
              y: _this.controls.target.y,
              z: _this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP = { //新的相机位置
              x: 10.7,
              y: 1.6,
              z: -3.2,
            }
            _this.tweenCamera(oldP, oldT, newP, newT);
            if(item.id == 0){ //ABC
              _this.ShowHideComponents(["BRG_B","BRG_R","BRG_G","ABC","ABCG","ZCGB","CGB"],true)
              _this.transparentComponents(["ABC","ZCGB","CGB"],0.3)
              _this.ShowHideComponents(["XZ","ABBG2","ABAG","XZNB"],false)

              _this.tweenplane = new TWEEN.Tween(_this.localPlane_BRG_R).to({constant: 4}, 7700);
              _this.tweenplane.onUpdate(function () { //第一阶段
                _this.model.getObjectByName("BRG_R").material.clippingPlanes = [_this.localPlane_BRG_R];
              })
              _this.tweenplane.start();

              _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRG_B).to({normal:{x:1,y:0,z:0},constant:-0.35}, 2000);
              _this.tweenplane2.onUpdate(function () { //第一阶段
                let plane_1 = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.model.getObjectByName("BRG_B").material.clippingPlanes = [_this.localPlane_BRG_B,plane_1];
              }).onComplete(function(){
                _this.localPlane_BRG_B = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRG_B).to({normal:{x:0,y:1,z:0},constant: 4}, 6000);
                _this.tweenplane2.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRG_B").material.clippingPlanes = [_this.localPlane_BRG_B];
                })
                _this.tweenplane2.start();
              })
              _this.tweenplane2.start();

              _this.tweenplane3 = new TWEEN.Tween(_this.localPlane_BRG_G).to({normal:{x:-1,y:0,z:0},constant:-0.35}, 2000);
              _this.tweenplane3.onUpdate(function () { //第一阶段
                let plane_1 = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.model.getObjectByName("BRG_G").material.clippingPlanes = [_this.localPlane_BRG_G,plane_1];
              }).onComplete(function(){
                _this.localPlane_BRG_G = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.tweenplane3 = new TWEEN.Tween(_this.localPlane_BRG_G).to({normal:{x:0,y:1,z:0},constant: 4}, 6000);
                _this.tweenplane3.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRG_G").material.clippingPlanes = [_this.localPlane_BRG_G];
                })
                _this.tweenplane3.start();
              })
              _this.tweenplane3.start();



            }else if(item.id == 1){ //ABB
              _this.ShowHideComponents(["XZ","BRR_B","BRR_R","ABBG2","ZCGB","CGB"],true)
              _this.transparentComponents(["XZ","ZCGB","CGB"],0.3)
              _this.ShowHideComponents(["ABAG","XZNB","ABC"],false)
              // ----------------------------------------------------------------------------------------
              _this.tweenplane = new TWEEN.Tween(_this.localPlane_BRR_R).to({constant: 4}, 7500);
              _this.tweenplane.onUpdate(function () { //第一阶段
                _this.model.getObjectByName("BRR_R").material.clippingPlanes = [_this.localPlane_BRR_R];
              })
              _this.tweenplane.start();

              _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRR_B).to({normal:{x:1,y:0,z:0},constant:-0.35}, 1600);
              _this.tweenplane2.onUpdate(function () { //第一阶段
                let plane_1 = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.model.getObjectByName("BRR_B").material.clippingPlanes = [_this.localPlane_BRR_B,plane_1];
              }).onComplete(function(){
                _this.localPlane_BRR_B = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRR_B).to({normal:{x:0,y:1,z:0},constant: 4}, 6000);
                _this.tweenplane2.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRR_B").material.clippingPlanes = [_this.localPlane_BRR_B];
                })
                _this.tweenplane2.start();
              })
              _this.tweenplane2.start();


            }else if(item.id ==2){ //ABA
              _this.ShowHideComponents(["XZ","BRB_B","BRB_R","ZCGB","CGB"],true)
              _this.transparentComponents(["XZ","ZCGB","CGB"],0.3)
              _this.ShowHideComponents(["XZNB"],false)
              // ----------------------------------------------------------------------------------------
              _this.tweenplane = new TWEEN.Tween(_this.localPlane_BRB_R).to({constant: 4}, 7500);
              _this.tweenplane.onUpdate(function () { //第一阶段
                _this.model.getObjectByName("BRB_R").material.clippingPlanes = [_this.localPlane_BRB_R];
              })
              _this.tweenplane.start();
              _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRB_B).to({normal:{x:1,y:0,z:0},constant:-0.35}, 1600);
              _this.tweenplane2.onUpdate(function () { //第一阶段
                let plane_1 = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.model.getObjectByName("BRB_B").material.clippingPlanes = [_this.localPlane_BRB_B,plane_1];
              }).onComplete(function(){
                _this.localPlane_BRB_B = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.45)
                _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRB_B).to({normal:{x:0,y:1,z:0},constant: 4}, 6000);
                _this.tweenplane2.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRB_B").material.clippingPlanes = [_this.localPlane_BRB_B];
                })
                _this.tweenplane2.start();
              })
              _this.tweenplane2.start();
            }
          },
          /**
           * @description 配件菜单选项按钮
           */
          focusaccessory(item){
            let _this = this
            _this.toobarActive = null
            // _this.initmodel()
            _this.hideallcomponents()
            this.img_annotate_status = false
            if(this.clipAction){ //如果有动画则先停止播放
              this.clipAction.stop()
              this.attentionStatus = false
            }
            if(_this.accessoryActive == item.id){
              _this.initmodel()
              _this.accessoryActive = null
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 10,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }else{
              _this.accessoryActive = item.id
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              switch (item.id) {
                case 0: //排序杆3 ABA
                  var newT = { //新的聚焦位置
                    x: 1.24,
                    y: 1.6,
                    z: 4.05,
                  }
                  var newP = { //新的相机位置
                    x: 5,
                    y: 2.8,
                    z: 7.7,
                  }
                  _this.testShowHideComponents("ABAGK")
                  // _this.transparentComponents2(["ABAGK"],0.8)
                  // _this.ShowHideComponents(["ABAGK"],true)
                  break;
                case 1: //排序杆4 ABC
                  var newT = { //新的聚焦位置
                    x: -0.76,
                    y: 1.6,
                    z: 4.05,
                  }
                  var newP = { //新的相机位置
                    x: 3,
                    y: 2.8,
                    z: 7.7,
                  }
                  _this.testShowHideComponents("ABCGK")
                  // _this.ShowHideComponents(["ABCGK"],true)
                  break;
                case 2: //排序杆1 ABB
                  var newT = { //新的聚焦位置
                    x: -2.27,
                    y: 1.59,
                    z: 4.05,
                  }
                  var newP = { //新的相机位置
                    x: 1,
                    y: 2.8,
                    z: 7.7,
                  }
                  _this.testShowHideComponents("ABBG")
                  // _this.ShowHideComponents(["ABBG"],true)
                  break;
                case 3: //排序杆2 BBA
                var newT = { //新的聚焦位置
                    x: -4.19,
                    y: 1.59,
                    z: 4.05,
                  }
                  var newP = { //新的相机位置
                    x: -1,
                    y: 2.8,
                    z: 7.7,
                  }
                  _this.testShowHideComponents("BBAG")
                  // _this.ShowHideComponents(["BBAG"],true)
                  break;
                case 4: //排序杆3 BBB
                  var newT = { //新的聚焦位置
                    x: -6.09,
                    y: 1.59,
                    z: 4.05,
                  }
                  var newP = { //新的相机位置
                    x: -3,
                    y: 2.8,
                    z: 7.7,
                  }
                  _this.testShowHideComponents("BBBG")
                  // _this.ShowHideComponents(["BBBG"],true)
                  // _this.ShowHideComponents(["XB1","XB2"],true)
                  // _this.ShowHideComponents(["XB3","XB4"],false)
                  break;
                case 5: //芯棒1 B1
                  var newT = { //新的聚焦位置
                    x: 0.37,
                    y: -0.89,
                    z: 6.36,
                  }
                  var newP = { //新的相机位置
                    x: 0.37,
                    y: -0.89,
                    z: 12.39,
                  }
                  _this.testShowHideComponents("B1")
                  // _this.ShowHideComponents(["B1"],true)
                  break;
                case 6: //芯棒2 B2
                  var newT = { //新的聚焦位置
                    x: 0.37,
                    y: -0.89,
                    z: 5.37,
                  }
                  var newP = { //新的相机位置
                    x: 0.37,
                    y: -0.89,
                    z: 11.37,
                  }
                  _this.testShowHideComponents("B2")
                  // _this.ShowHideComponents(["B2"],true)
                  break;
                case 7: //芯棒3 B3
                  var newT = { //新的聚焦位置
                    x: 0.37,
                    y: -0.89,
                    z: 4.35,
                  }
                  var newP = { //新的相机位置
                    x: 0.37,
                    y: -0.89,
                    z: 10.35,
                  }
                  _this.testShowHideComponents("B3")
                  // _this.ShowHideComponents(["B3"],true)
                  break;

                default:
                  break;
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          /**
           * @description 初始化平面
           */
          initlocalPlane(){
            let _this = this;

            _this.localPlane_BRG_B = new THREE.Plane(new THREE.Vector3(1, 0, 0), -1.8)
            _this.localPlane_BRG_R = new THREE.Plane(new THREE.Vector3(0, 1, 0), -3.5)
            _this.localPlane_BRG_G = new THREE.Plane(new THREE.Vector3(-1, 0, 0), -1.8)

            _this.localPlane_BRR_B = new THREE.Plane(new THREE.Vector3(1, 0, 0), -1.3)
            _this.localPlane_BRR_R = new THREE.Plane(new THREE.Vector3(0, 1, 0), -3)

            _this.localPlane_BRB_B = new THREE.Plane(new THREE.Vector3(1, 0, 0), -1.3)
            _this.localPlane_BRB_R = new THREE.Plane(new THREE.Vector3(0, 1, 0), -3)

            _this.model.getObjectByName("BRG_B").material.clippingPlanes = [_this.localPlane_BRG_B];
            _this.model.getObjectByName("BRG_R").material.clippingPlanes = [_this.localPlane_BRG_R];
            _this.model.getObjectByName("BRG_G").material.clippingPlanes = [_this.localPlane_BRG_G];

            _this.model.getObjectByName("BRR_B").material.clippingPlanes = [_this.localPlane_BRR_B];
            _this.model.getObjectByName("BRR_R").material.clippingPlanes = [_this.localPlane_BRR_R];

            _this.model.getObjectByName("BRB_B").material.clippingPlanes = [_this.localPlane_BRB_B];
            _this.model.getObjectByName("BRB_R").material.clippingPlanes = [_this.localPlane_BRB_R];
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                console.log("射线器返回对象", intersects);
              }else{
                console.log('null');
              }
            })
          },
          /**
           * @description 显示所有组件
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.depthWrite = true
                object.material.opacity = 1
              }
            })
          },
          /**
           * @description 隐藏所有组件
           */
          hideallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              if(object.isMesh){
                object.visible = false
              }
            })
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          /**
           * @description 显示透明组件
           * @param {array} e 透明名列表
           * @param {Boolean} e （0透明）or（1显示）
           */
          transparentComponents(objectArray,opcity,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              console.log(objectArray);
              console.log(objectArray.length);
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.depthWrite = false
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          transparentComponents2(objectArray,opcity,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = true
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                // console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          testShowHideComponents(name){
            let obj = this.model.getObjectByName(name)
            obj.visible = true
            if(obj.children){
              for (let i = 0; i < obj.children.length; i++) {
                obj.children[i].visible = true
              }
            }
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // _this.transparentComponents(["XZ","ABC"],0.4)
            // _this.transparentComponents(["ABC","XZ"],0.4)

            // _this.ShowHideComponents(["ABC","BRG_B","BRG_R","BRG_G","ABCG"],false)
            // _this.ShowHideComponents(["XZNB"],false)

            // _this.model.getObjectByName("ZK").visible = false
            // _this.transparentComponents(["ZK"])
            // console.log(_this.model.getObjectByName("YBY"),"YBY");
            // _this.model.getObjectByName("ABBX").visible = false
            // _this.transparentComponents(["XC"],)
            // console.log(_this.model.getObjectByName("XZ"));
            // for (let i = 1; i < 7; i++) {
            //   console.log(_this.model.getObjectByName("HG"+i),"HG"+i);
            // }

            // if(_this.helper){
            //   _this.scene.remove( _this.helper );
            // }
            // _this.localPlaneRED1 = new THREE.Plane(new THREE.Vector3(0, 1, 0), -4)
            // _this.helper = new THREE.PlaneHelper( _this.localPlaneRED1, 1, 0xff0000 );
            // _this.scene.add( _this.helper );

            // _this.model.getObjectByName("ABBX").material.clippingPlanes = [_this.localPlaneRED1];

            // _this.tweenplane = new TWEEN.Tween(_this.localPlaneRED1).to({constant: 4}, 6000);
            // _this.tweenplane.onUpdate(function (object) { //第一阶段
            //   _this.model.getObjectByName("ABBX").material.clippingPlanes = [_this.localPlaneRED1];
            // })
            // _this.tweenplane.start();
          },
        },
        mounted: function () {
          let _this = this;
          _this.initCanvas();
          _this.timer = setInterval(function() {
              if ( !_this.hadLoaded ) {
                  if ( _this.loadprogress < 80 ) {
                      _this.loadprogress += 0.8;
                  } else if ( _this.modelLoaded ) {
                      if ( _this.loadprogress <= 100 ) {
                          _this.loadprogress += 2;
                      } else {
                          _this.hadLoaded = true;
                          clearInterval(_this.timer);
                          _this.timer = null;
                      }
                  }
              }
          }, 20);
          // this.raycasterclick()
          window.addEventListener("resize", _this.onResize, false);
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },

    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  .sub-nav{
    position: absolute;
    top: 50%;
    right: 50px;
  }
  .sub-item{
    background-color: #34353a;
    border-radius: 5px;
    color: #fff;
    padding: 10px 15px;
    margin: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .accessoryactive{
    background-color: #e71629 !important;
  }
  .img_annotate{
    position: absolute;
    top: 15%;
    right: 50px;
    width: 350px;
    /* background-color: #585a5cc2; */
    /* background-color: rgba(88,90,92,0.7); */
    /* opacity: 0.7; */
    padding: 20px;
    border-radius: 10px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .img_annotate img{
    width: 100%;
  }
  .img_annotate video{
    width: 100%;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/scbyfpq.vue